module.exports = __webpack_public_path__ + "static/media/sidebar.e3953ffa.png";